import { Box } from "@mui/material";
import { styled, Theme, useMediaQuery } from "@mui/system";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import ApprovalOutlinedIcon from "@mui/icons-material/ApprovalOutlined";
import HelpOutlinedIcon from "@mui/icons-material/HelpOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

const RightSideBarBarWrapper = styled(Box)(({ theme }) => ({
  background: "#ffffff",
  height: "100vh",
  width: "100%",
  paddingLeft: 5,
  paddingRight: 5,
  transition: "width 0.3s ease",
  [theme.breakpoints.down("md")]: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    height: 80,
    marginTop: "auto",
    display: "flex",
    flexDirection: "row",
    zIndex: 1000,
    borderTop: "1px solid #D9D9D9",
    ".task-item": {
      height: "86px",
      ".label": {
        marginTop: "2px",
      },
    },
  },
}));

const RightSideBar = () => {
  const list = [
    {
      title: "Tasks",
      icon: <TaskOutlinedIcon />,
      bgColor: "#FDBB1B",
      onClick: () => {},
    },
    {
      title: "Approvals",
      icon: <ApprovalOutlinedIcon />,
      bgColor: "#FF8012",
      onClick: () => {},
    },
    {
      title: "Help",
      icon: <HelpOutlinedIcon />,
      bgColor: "#04B5FC",
      onClick: () => {},
    },
    {
      title: "Settings",
      icon: <SettingsOutlinedIcon />,
      bgColor: "#96A2C0",
      onClick: () => {},
    },
  ];

  return (
    <>
      <RightSideBarBarWrapper className="task-bar">
        {list?.map((item: any, index: any) => (
          <Box
            key={`task-item-${index}`}
            sx={{ ...styles.taskContainer }}
            className="task-item"
          >
            <Box sx={{ ...styles.iconWrapper, background: item?.bgColor }}>
              {item?.icon}
            </Box>
            <Box sx={{ ...styles.label }} className="label">
              {item.title}
            </Box>
          </Box>
        ))}
      </RightSideBarBarWrapper>
    </>
  );
};

const styles = {
  icon: {
    size: 30,
    backgroundColor: "#ffffff",
  },
  iconWrapper: {
    borderRadius: "50%",
    width: 40,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#ffffff",
  },
  taskContainer: {
    width: "100%",
    height: 100,
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid #D9D9D9",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
  },
  label: {
    marginTop: 1,
    fontSize: 12,
    fontWeight: 500,
  },
};

export default RightSideBar;
